var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({staticClass:"llm-delete-icon-btn",class:`llm-delete-icon-btn--${_vm.size}`,attrs:{"title":_vm.title,"role":"button","tabindex":"0"}},_vm.$listeners),[_c('Icon',{attrs:{"type":"ios-trash-outline","size":_vm.iconSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }